import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { heading3 } from 'app/livbrite/resources/theme/css'

export const HeaderContainer = styled.div`
  padding: 30px 60px;
  text-align: center;
  background: ${props => props.theme.palette.general.light};
  color: ${props => props.theme.palette.primary.alphaDark};

  p {
    font-weight: bold;
  }
`

export const ProductContainer = styled.div`
  display: flex;
  padding: 30px 60px;
  text-align: center;
  background: ${props => props.theme.palette.general.soft};
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  .column {
    flex: 1;

    &--image {
      max-width: 45%;
      min-width: 200px;
      ${bp('sm')`
        max-width: 100%;
      `}

      img {
        max-width: 100%;
        max-height: 300px;
        width: auto;
      }
    }

    &--info {
      text-align: left;
      margin-left: 20px;
      color: ${props => props.theme.palette.primary.alphaDark};

      strong {
        font: ${font('default', 'bold', '20px/1.5')};
        display: block;
        margin-bottom: 15px;
      }

      > div {
        display: flex;

        svg {
          min-width: 30px;
          height: 30px;
          fill: ${props => props.theme.palette.primary.alphaDark};
        }

        p {
          color: ${props => props.theme.palette.general.strong};
          line-height: 1.5;
          margin-bottom: 20px;
        }

        &.note {
          flex-direction: column;

          h2 {
            text-transform: none;
            text-align: left;
          }
        }

        &.product-price {
          align-items: flex-end;
          margin-bottom: 15px;

          .regularPrice {
            font-size: 24px;
            margin-right: 10px;
          }
        }
      }
    }
  }
`

export const InfoContainer = styled.div`
  background: ${props => props.theme.palette.general.light};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 60px;
  border-radius: 0 0 7px 7px;

  h3,
  h5 {
    ${heading3}
    font-size: 18px;
    margin: 0 auto 5px;
  }

  p {
    text-align: center;
    font: ${font('default', 'medium', '16px/1.2')};
    color: ${props => props.theme.palette.primary.alphaDark};
  }

  button {
    text-transform: uppercase;
    font-weight: ${props => props.theme.font.default.bold};
  }

  .info {
    &__items {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      margin: 20px auto 40px;
    }

    &__item {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
    }

    &__shipment {
      margin-bottom: 40px;

      > p {
        margin: 0 auto 30px;
      }

      h5 {
        text-align: center;
      }
    }

    &__actions {
      width: 100%;
      padding: 30px 60px;
      margin: 40px 0;
      text-align: center;
      background: ${props => props.theme.palette.general.soft};

      a {
        color: ${props => props.theme.palette.primary.alphaDark};

        &:hover {
          opacity: 0.8;
        }
      }

      + button {
        background: ${props => props.theme.palette.primary.beta};
        text-transform: none;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    &__options {
      width: 30%;
      ${bp('sm')`
        width: 90%;
      `}
    }
  }

  .warning {
    color: ${props => props.theme.palette.state.danger};
  }
`
